import certifications from "./certifications.json";
import en from "./en.json";
import fi from "./fi.json";
import languages from "./languages.json";
import skills from "./skills.json";
import sv from "./sv.json";

export const translations = {
  fi,
  en,
  sv,
  skills,
  certifications,
  languages,
};
